import type { FC } from "react";
import { SortingButtonWrapper, StyledButton } from "app/components/filters-bar/country-filter/StyledComponent";
import { SWReactIcons } from "@similarweb/icons";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import { ESortingType } from "app/components/filters-bar/country-filter/CountryFilterTypes";
import classNames from "classnames";
import type { ICountryDropdownItem } from "@similarweb/ui-components";
import { allTrackers } from "app/services/track/track";

interface ISortingOptionProps {
    sortingByDataTxt: string;
    sortChange: (sortingType: ESortingType) => void;
    sortingType: number;
    onChangeSortingType: (newType: any) => void;
}

export const SortingOption: FC<ISortingOptionProps> = ({
    sortingByDataTxt,
    sortChange,
    sortingType,
    onChangeSortingType,
}) => {
    const translate = useTranslation();
    const sortingByCountryTxt = translate("country.filter.sorting.by.country.name");
    const sortByName = () => {
        if (sortingType !== ESortingType.NAME) {
            allTrackers.dispatchTrackEvent("Drop Down", "click", "Country Filter Header/ Country");
            sortChange(ESortingType.NAME);
            onChangeSortingType(ESortingType.NAME);
        }
    };
    const sortByData = () => {
        if (sortingType !== ESortingType.DATA) {
            allTrackers.dispatchTrackEvent("Drop Down", "click", "Country Filter Header/ Ranking");
            sortChange(ESortingType.DATA);
            onChangeSortingType(ESortingType.DATA);
        }
    };
    return (
        <SortingButtonWrapper>
            <StyledButton
                type="flat"
                onClick={sortByName}
                className={classNames("DropdownButton-sortByCountry")}
            >
                {sortingByCountryTxt}
                {sortingType === ESortingType.NAME ? (
                    <SWReactIcons
                        iconName="arrow-down"
                        size={"xs"}
                    />
                ) : null}
            </StyledButton>
            <StyledButton
                type="flat"
                onClick={sortByData}
                className={classNames("DropdownButton-sortByData")}
            >
                {sortingType === ESortingType.DATA ? (
                    <SWReactIcons
                        iconName="arrow-down"
                        size={"xs"}
                    />
                ) : null}
                {sortingByDataTxt}
            </StyledButton>
        </SortingButtonWrapper>
    );
};

export const americaStatesHandle = (
    countries: ICountryDropdownItem[],
    selectedItem: ICountryDropdownItem,
): ICountryDropdownItem[] => {
    const US_ID = 840;
    let USStates: ICountryDropdownItem[] = [];
    const notUSState: ICountryDropdownItem[] = [];
    countries.forEach((country) => {
        const isNotSelectedCountry = country.id !== selectedItem.id;
        if (isNotSelectedCountry) {
            country.isLastPermitted = false;
            if (selectedItem.id === US_ID) {
                country.parent ? USStates.push(country) : notUSState.push(country);
            } else if (selectedItem?.parent == US_ID) {
                let US = {};
                if (country.id === US_ID) {
                    US = { ...country };
                    USStates = [US, ...USStates];
                } else if (country.parent && country.id != selectedItem.id) {
                    USStates.push(country);
                } else {
                    notUSState.push(country);
                }
            }
        }
    });
    const nonSelectedCountries = [...USStates, ...notUSState];
    for (let i = 0; i < nonSelectedCountries.length; i++) {
        if (nonSelectedCountries[i + 1]?.permitted === false && nonSelectedCountries[i].permitted) {
            nonSelectedCountries[i].isLastPermitted = true;
            break;
        }
    }
    return nonSelectedCountries;
};
